import React from 'react';

interface FAQ {
  question: string;
  answer: string;
}

interface StructuredDataProps {
  type: 'website' | 'calculator' | 'organization' | 'faq' | 'breadcrumb';
  data: any;
}

const StructuredData: React.FC<StructuredDataProps> = ({ type, data }) => {
  const generateStructuredData = () => {
    switch (type) {
      case 'website':
        return {
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "Larry's Help",
          "description": "Free financial calculators for Canada and the US (retirement, housing, car, career, income tax, payroll, forecast), free bookkeeping software with HST/GST tracking, and a Calendly-style scheduling platform. One free account for all of it.",
          "url": "https://larryshelp.org",
          "potentialAction": {
            "@type": "SearchAction",
            "target": "https://larryshelp.org/search?q={search_term_string}",
            "query-input": "required name=search_term_string"
          },
          "sameAs": [
            "https://larryshelp.org"
          ]
        };

      case 'calculator':
        return {
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          "name": data.name,
          "description": data.description,
          "applicationCategory": "FinanceApplication",
          "operatingSystem": "Web Browser",
          "url": data.url,
          "offers": {
            "@type": "Offer",
            "price": "0",
            "priceCurrency": "CAD",
            "availability": "https://schema.org/InStock"
          },
          "provider": {
            "@type": "Organization",
            "name": "Larry's Help",
            "url": "https://larryshelp.org"
          }
        };

      case 'organization':
        return {
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Larry's Help",
          "description": "Financial planning and retirement calculator platform",
          "url": "https://larryshelp.org",
          "logo": "https://larryshelp.org/logo512.png",
          "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "customer service",
            "email": "support@larryshelp.org"
          },
          "sameAs": [
            "https://larryshelp.org"
          ]
        };

      case 'faq':
        return {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": data.faqs.map((faq: FAQ) => ({
            "@type": "Question",
            "name": faq.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": faq.answer
            }
          }))
        };

      case 'breadcrumb':
        return {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": data.items.map((item: any, index: number) => ({
            "@type": "ListItem",
            "position": index + 1,
            "name": item.name,
            "item": item.url
          }))
        };

      default:
        return {};
    }
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(generateStructuredData())
      }}
    />
  );
};

export default StructuredData; 